import {
  Contact,
  ContactListService,
  ContactsByRelationQuery,
  ContactsSearchQuery,
  ContactsSearchModel
} from 'capability-ng-resources';
import * as _4 from 'lodash4';

export class MyPeopleListController {
  private searchPeople: () => void;
  private isSearching: boolean = !_4.isEmpty(this.searchTerm);

  constructor(
    private ngContactsByRelationQuery: ContactsByRelationQuery,
    private $state: ng.ui.IStateService,
    private ngContactListService: ContactListService,
    private ngContactsSearchModel: ContactsSearchModel,
    private ngContactsSearchQuery: ContactsSearchQuery,
    private $stateParams: ng.ui.IStateParamsService
  ) {
    this.ngContactListService.loadContacts($stateParams.activeRelation);
  }

  $onInit(): void {
    this.searchPeople = this.search.bind(this);
  }

  hasRelationships(): boolean {
    return !_4.isEmpty(this.ngContactsByRelationQuery.result.relationships);
  }

  setActiveRelationship(event: JQueryEventObject): void {
    const relationship = _4.get(event, 'detail.value', this.$stateParams.activeRelation);
    this.$state.params.activeRelation = relationship;
    this.ngContactListService.activateRelationship(relationship);
  }

  isActiveRelationship(relationship: string): boolean {
    return _4.isEmpty(this.ngContactListService.activeRelationship)
      ? false
      : relationship === this.ngContactListService.activeRelationship;
  }

  search(term: string) {
    this.isSearching = !_4.isEmpty(term);
    this.ngContactsSearchModel.write({ searchTerm: term });
    this.ngContactsSearchQuery.run();
  }

  get searchTerm(): string {
    const { searchTerm } = this.ngContactsSearchModel.read();
    return searchTerm;
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/views/my_people_list/my_people_list.ts